import Avatar from '../../assets/jonah-headshot.png';

// ── Author shown on every article byline ──
export const author = {
  name: 'Jonah Odoh',
  role: 'Senior Software Engineer',
  avatar: Avatar,
};

// ── Topic / category definitions ──
// Each post's `category` field must match one of these slugs.
export const topics = [
  {
    slug: 'ai',
    name: 'AI',
    blurb: 'RAG, LLM pipelines, and shipping models into production.',
  },
  {
    slug: 'backend',
    name: 'Backend',
    blurb: 'APIs, data models, and systems that hold up under load.',
  },
  {
    slug: 'devops',
    name: 'DevOps',
    blurb: 'Kubernetes, Docker, CI/CD, and the path to production.',
  },
  {
    slug: 'aws',
    name: 'AWS',
    blurb: 'Building and running real workloads on Amazon Web Services.',
  },
  {
    slug: 'gcp',
    name: 'GCP',
    blurb: 'Lessons from running production systems on Google Cloud.',
  },
];

export const getTopic = (slug) => topics.find((t) => t.slug === slug);

// ── Footer + social links ──
export const socials = {
  linkedin: 'https://www.linkedin.com/in/odoh-jonah/',
  twitter: 'https://twitter.com/omonuj',
  email: 'mailto:jonahodoh@gmail.com',
};
